export default {
    "brand-name": "NoShow",
    "main-color": "#083e60",
    "main-color-light": "#30a4b7",
    "main-color-rgb": "8, 62, 96",
    "main-color-light-rgb": "48, 164, 183",
    "default-page-background": "linear-gradient(180deg, #ffffff 0%, #f6fbfe 44%, #edf6fb 100%)",
    "auth-page-background": "linear-gradient(135deg, #ffffff 0%, #f6fbfd 48%, #eef8fb 100%)",
    "auth-text-color": "#16323d",
    "auth-muted-color": "#647984",
    "auth-label-color": "#263f4a",
    "auth-field-border-rgb": "38, 63, 74",
    "auth-success-shadow-rgb": "48, 164, 183",
    "auth-visual-shadow-rgb": "8, 62, 96",
    "auth-visual-overlay-rgb": "10, 50, 67",
    "auth-visual-panel-rgb": "9, 43, 58",
    "account-panel-background": "#083e60",
    "account-panel-border-color": "rgba(8, 62, 96, 0.18)",
    "module-card-background": "linear-gradient(180deg, #ffffff 0%, #fbfdff 100%)",
    "module-card-border-rgb": "8, 62, 96",
    "module-card-line-rgb": "8, 62, 96",
    "module-icon-color": "#ffffff",
    "module-icon-background": "linear-gradient(145deg, #083e60, #0b5d87)",
    "module-icon-border-color": "transparent",
    "module-icon-shadow-rgb": "8, 62, 96",
    "module-action-shadow-rgb": "8, 62, 96",
    "btn-danger": "#f75b61",
    "btn-warning": "#ffc107",
};
